import React from 'react'
import AreaChart from './components/AreaChart'


const App = () => {
  return (
    <div>
      <h1>COVID-19 Country Overview</h1>
      <div className='container'>
      <AreaChart/>
      </div>


    </div>
  )
}

export default App